import api from "@/services/api";

const { get } = api.getPrefixedMethods("auth");

export default {
  // { canSwitch, homeCompanyId, activeCompanyId, companies: [{ id, name }] }
  getOptions() {
    return get("active-company/options");
  },
};
